import { createContext } from 'react';
import type { Dispatch, SetStateAction } from 'react';
import type { RegulationContract } from '@raas/shared/src/features/regulation/contracts/regulation.type';
import type { PaginationParamsContract } from '@raas/shared/src/features/pagination';

export interface RegulationListDataContextContract {
  regulations: RegulationContract[] | null;
  isListLoading: boolean;
  nextCursor: string | null;
  hasMore: boolean;
  paginationParams: PaginationParamsContract;
  setRegulations: Dispatch<SetStateAction<RegulationContract[]>>;
  setIsListLoading: (isLoading: boolean) => void;
  setNextCursor: (cursor: string | null) => void;
  setHasMore: (hasMore: boolean) => void;
  setPaginationParams: Dispatch<SetStateAction<PaginationParamsContract>>;
}

const RegulationListDataContext = createContext<RegulationListDataContextContract | undefined>(
  undefined
);

export default RegulationListDataContext;
